import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';

import { edm } from '../../../environment/edm';
import { schema } from '../../../environment/schema';
import { parseSearch, getDefaultHeaderObj } from '../../../request-contract-helper';

const DEFAULT_FIELDS = [
  'HasCampaigns',
  'HasNotPausedCampaigns',
  'HasAdGroups',
  'HasNotPausedAdGroups',
  'HasAds',
  'HasNotPausedAds',
  'HasKeywords',
  'HasNotPausedKeywords',
  'HasActiveNonDefaultCampaigns',
];

function odataUrlFactory(params) {
  const { variables } = params;

  const {
    locator,
    select = DEFAULT_FIELDS,
  } = variables;

  const { descriptor } = locator;
  const { cid, aid } = descriptor;
  const entity = edm
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid);
  const search = {
    select,
  };

  const parsedSearch = parseSearch(search, entity);
  const searchCompact = _.omit(parsedSearch, x => _.isNull(x) || _.isUndefined(x));
  const searchString = _.isEmpty(searchCompact) ? '' : `?${queryString.stringify(searchCompact)}`;

  return `${entity.path}/Default.AlertInformation()${searchString}`;
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}

function processor(response, request) {
  const {
    variables: {
      locator: {
        descriptor: {
          aid,
        },
      },
    },
  } = request;

  return {
    ...response,
    Id: aid,
  };
}

export const fetchRequestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:alert_information',
  verb: requestVerbs.GET,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: odataHeaderFactory,
  keySelector: alertInformation => alertInformation.Id,
});

export const fetchResponseContract = createResponseContract({
  requestContract: fetchRequestContract,
  responseType: responseTypes.ENTITY,
  keySelector: alertInformation => alertInformation.Id,
  processorFn: processor,
});
